// test345
(345 && 0);
